import script from "./HeaderSearch.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeaderSearch.vue?vue&type=script&lang=ts&setup=true"

import "./HeaderSearch.vue?vue&type=style&index=0&id=5275dd37&scoped=true&lang=css"
import "./HeaderSearch.vue?vue&type=style&index=1&id=5275dd37&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5275dd37"]])

export default __exports__